module.exports = __webpack_public_path__ + "static/media/error2.be5b5a76.svg";